export interface TsAppVersion {
    version: string;
    name: string;
    description?: string;
    versionLong?: string;
    versionDate: string;
    gitCommitHash?: string;
    gitCommitDate?: string;
    gitTag?: string;
};
export const versions: TsAppVersion = {
    version: '6.9.2',
    name: '@digitaservice/app',
    versionDate: '2026-09-21T09:14:31.282Z',
    gitCommitHash: 'bdbc56673',
    versionLong: '6.9.2-bdbc56673',
};
export default versions;
